export enum LocationType {
	CITY = 'CITY',
	PROVINCE = 'PROVINCE',
	REGION = 'REGION',
}
